import React from "react";
import PropTypes from "prop-types";
import { Query } from "react-apollo";

import ErrorPage from "components/Library/ErrorPage";
import GET_ERROR from "./ErrorPageWrapper.graphql";


/* 
 * ErrorPageWrapper wraps ErrorPage in a Query because: 
 * 1. ErrorPage need's access to the client so it can write errors to the Apollo cache directly.
 * 2. It allows ErrorPage to update when the error changes, which happens when clicking away from an error page.
 */
export default function ErrorPageWrapper({ children }) {
  return (
    <Query query={GET_ERROR}>
      {({ data, client }) => {
        return <ErrorPage {...{ data, client, children }} />;
      }}
    </Query>
  );
}

ErrorPageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
